import React from "react";
import { Link } from "react-router-dom";

const CtaArea = () => {
  return (
    <>
      {/* CTA AREA START */}
      <div className="cta">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="heading1-w">
                <h2 className="title tg-element-title">Get in Touch</h2>
                <div className="space16"></div>
                <p data-aos="fade-right" data-aos-duration="700">
                  Not sure yet and want to try it first? No worries—we've got
                  you covered with a free plan{" "}
                </p>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="buttons">
                <Link className="cta-btn1" to="/dashboard">
                  Start Free Plan
                  <span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </Link>
                {/* <Link className="cta-btn2" to="/contact">Explore Solution <span><i className="fa-solid fa-arrow-right"></i></span></Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CTA AREA END */}
    </>
  );
};

export default CtaArea;
